import React, { Component } from "react";
import { validForm } from "./formValid";
import "./App.css";

const Input = ({
  disabled,
  max,
  min,
  name,
  pattern,
  placeholder,
  onChange,
  onKeyPress,
  required,
  value,
  type
}) => (
  <div className={`row ${required && "esential-field"}`}>
    <input
      disabled={disabled}
      maxLength={max}
      minLength={min}
      onKeyPress={onKeyPress}
      onChange={onChange}
      pattern={pattern}
      name={name}
      placeholder={placeholder}
      required={required}
      type={type}
      value={value}
    />
  </div>
);

const Button = ({ onClick, title }) => (
  <div className="cont-button">
    <button className="button" onClick={onClick}>
      {title}
    </button>
  </div>
);

class App extends Component {
  state = {
    slides: 1,
    document_type: 0,
    tipo_documento: 0,
    open: false,
    docTypes: [],
    recaptchaTime: 1,
    user: {
      nombres: ""
    },
    urlFetch: "",
    urlPath: "/static/landing/beneficiario-registro/",
    siteKey: "",
    isMounted: false
  };

  scrollend = slideNumber => {
    this.setState(
      () => ({ slides: slideNumber }),
      () => {
        if (slideNumber === 2) {
          window.ga("gtm1.send", {
            hitType: "event",
            eventCategory: "Beneficiario",
            eventAction: "stepview",
            eventLabel: "Screen Login"
          });
          window.formLogin && window.formLogin.reset();
          this.setState({ user: { nombres: "" } });
        }
        if (slideNumber === 3) {
          window.ga("gtm1.send", {
            hitType: "event",
            eventCategory: "Beneficiario",
            eventAction: "stepview",
            eventLabel: "Screen Suscription"
          });
          window.formRegister.reset();
        }
        if (slideNumber === 4) {
          window.ga("gtm1.send", {
            hitType: "event",
            eventCategory: "Beneficiario",
            eventAction: "stepview",
            eventLabel: "Screen Completion"
          });
        }
        //slideNumber === 3 &&
        //let topSlide = document.querySelector(`.s${slideNumber}`).offsetTop;
        document.querySelector(
          ".content-screen"
        ).style.transform = `translateY(-${slideNumber - 1}00vh)`;
        //window.scroll({ top: topSlide, behavior: "smooth" });
      }
    );
  };

  handleLogin = event => {
    event.preventDefault();
    let captcha = document.getElementById("g-recaptcha-response").value;
    document.getElementById("captcha").value = captcha;
    let form = validForm(document.formLogin);
    if (form.valid) {
      if (!captcha) {
        this.setState({
          loginError: "Todos los campos son requeridos"
        });
        return;
      }
      let myHeaders = new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      });
      let myInit = {
        method: "POST",
        headers: myHeaders,
        body: form.body
      };
      fetch(`${this.state.urlFetch}/beneficiario/ws-authenticate`, myInit)
        .then(res => res.json())
        .then(data => {
          window.grecaptcha.reset();
          if (data.status) {
            this.setState({
              user: data.data,
              document_type: 0,
              loginError: "",
              inscriptionError: ""
            });
            this.scrollend(3);
          } else {
            this.setState({
              loginError: data.message
            });
          }
        })
        .catch(err => console.log("Err", err));
    }
  };

  handleInscription = event => {
    event.preventDefault();
    let form = validForm(document.formRegister);
    if (form.valid) {
      let myHeaders = new Headers({
        "Content-Type": "application/x-www-form-urlencoded"
      });
      let myInit = {
        method: "POST",
        headers: myHeaders,
        body: form.body
      };
      fetch(`${this.state.urlFetch}/beneficiario/ws-register`, myInit)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            this.scrollend(4);
          } else {
            this.setState({
              inscriptionError: data.message
            });
          }
        })
        .catch(err => console.log("Err", err));
    }
  };

  selectDocument = event => {
    let typeDocument = event.target;
    let nameSelect = {};
    if (typeDocument.value) {
      let nLetters =
        typeDocument.options[typeDocument.selectedIndex].dataset.length;
      nameSelect[typeDocument.name] = nLetters;
      this.setState({
        ...nameSelect
      });
    } else {
      nameSelect[typeDocument.name] = 0;
      this.setState({
        ...nameSelect
      });
    }
  };

  validInput = (event, mySelect) => {
    let charCode = event.which || event.keyCode;
    if (mySelect) {
      if (mySelect.value === "DNI") {
        !(charCode >= 48 && charCode <= 57) && event.preventDefault();
      } else {
        !(
          (charCode >= 45 && charCode <= 57) ||
          (charCode >= 65 && charCode <= 90) ||
          (charCode >= 97 && charCode <= 122)
        ) && event.preventDefault();
      }
    } else {
      !(charCode >= 48 && charCode <= 57) && event.preventDefault();
    }
  };

  validInputText = event => {
    let charCode = event.which || event.keyCode;
    charCode >= 48 && charCode <= 57 && event.preventDefault();
  };

  openModal = () => {
    this.setState({
      open: true
    });
  };

  componentDidMount() {
    let myHostOrigin = "";
    const envDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    !envDev && (myHostOrigin = window && window.location.origin);

    this.setState({
      urlFetch: myHostOrigin
    });

    fetch(`${myHostOrigin}/beneficiario/ws-route`)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          this.setState({
            urlPath: envDev ? "" : data.data.static
          });
        }
      })
      .catch(err => console.log("Err", err));

    fetch(`${myHostOrigin}/beneficiario/ws-document`)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          this.setState({
            docTypes: data.data
          });
        }
      })
      .catch(err => console.log("Err", err));

    fetch(`${myHostOrigin}/beneficiario/ws-captcha`)
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          this.setState({
            siteKey: data.data.siteKey,
            isMounted: true
          });
          window.grecaptcha.render(document.getElementById("g-captcha"), {
            sitekey: data.data.siteKey
          });
        }
      });
  }

  render() {
    const {
      isMounted,
      document_type,
      tipo_documento,
      docTypes,
      open,
      slides,
      siteKey,
      user,
      urlPath
    } = this.state;
    return (
      <div className="wrapper" ref={ref => (this.el = ref)}>
        <header>
          <div className="cont-logo">
            <a href="/">
              <img src={`${urlPath}/static/img/logo-header.png`} alt="Club El Comercio" />
            </a>
          </div>
        </header>
        <div className="content-screen">
          <div className="wrapper-screen">
            <div className="screen s1">
              <div className="container">
                <div className="col">
                  <div className="cont-middle-col">
                    <img src={`${urlPath}/static/img/box-screen1.png`} alt="Club El Comercio" />
                  </div>
                </div>
                <div className="col">
                  <div className="cont-middle-col">
                    <div className="cont-s1">
                      <div className="head-icon">
                        <img src={`${urlPath}/static/img/icon-beneficios.svg`} alt="Club El Comercio" />
                      </div>
                      <div className="title">
                        <h2>comparte</h2>
                        <h3>tus beneficios</h3>
                        <h4>con quien tu quieras</h4>
                      </div>
                      <Button
                        title="inscribe a un *beneficiario"
                        onClick={() => this.scrollend(2)}
                      />
                      <a className="info" onClick={this.openModal}>
                        *¿Quién puede ser un beneficiario?
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMounted && (
            <React.Fragment>
              {slides > 0 && (
                <div className="wrapper-screen">
                  <div className="screen s2">
                    <div className="container">
                      <div className="col-1">
                        <div className="cont-middle-col">
                          <form
                            autoComplete="off"
                            className="enterData"
                            name="formLogin"
                            noValidate
                            onSubmit={this.handleLogin}
                          >
                            <div className="num">
                              <span>1</span>
                            </div>
                            <div className="cont-form">
                              <div className="cont">
                                <h3>Si eres parte del Club El Comercio,</h3>
                                <h2>Ingresa tus datos</h2>
                                <div className="row">
                                  <select
                                    name="document_type"
                                    onChange={this.selectDocument}
                                    required
                                    ref={ref =>
                                      (this.documentLoginSelect = ref)
                                    }
                                  >
                                    <option value="">Tipo de documento</option>
                                    {docTypes.map((item, index) => (
                                      <option
                                        data-length={item.max_length}
                                        key={index}
                                        value={item.id}
                                      >
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <Input
                                  type="text"
                                  name="document_number"
                                  placeholder="Número de documento"
                                  disabled={!Boolean(document_type)}
                                  max={document_type}
                                  min={5}
                                  onKeyPress={event =>
                                    this.validInput(
                                      event,
                                      this.documentLoginSelect
                                    )
                                  }
                                  required
                                />
                                <div className="row">
                                  <div
                                    id="g-captcha"
                                    className="g-recaptcha"
                                    data-sitekey={siteKey}
                                  />
                                  <input
                                    type="hidden"
                                    name="captcha"
                                    id="captcha"
                                    required
                                    value=""
                                  />
                                </div>
                                <div className="row">
                                  <p className="error">
                                    {this.state.loginError}
                                  </p>
                                </div>
                                <div className="row">
                                  <Button title="Siguiente" />
                                </div>
                                <span className="quest">
                                  ¿No eres parte del Club?{" "}
                                  <a
                                    href="https://suscripciones.elcomercio.pe/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    regístrate aquí
                                  </a>
                                </span>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {slides > 0 && (
                <div className="wrapper-screen">
                  <div className="screen s3">
                    <div className="container">
                      <div className="col">
                        <div className="cont-middle-col">
                          <img src={`${urlPath}/static/img/icon-beneficios-big.svg`} alt="Club El Comercio" />
                        </div>
                      </div>
                      <div className="col">
                        <div className="cont-middle-col">
                          <div className="title">
                            <h2>Hola {user.nombres},</h2>
                            <span>
                              ¿No es tu usuario?{" "}
                              <a
                                href={undefined}
                                onClick={() => this.scrollend(2)}
                              >
                                REGRESA AQUÍ
                              </a>
                            </span>
                          </div>
                          <form
                            className="enterData"
                            onSubmit={this.handleInscription}
                            name="formRegister"
                            noValidate
                          >
                            <div className="num">
                              <span>2</span>
                            </div>
                            <div className="cont-form">
                              <div className="cont">
                                <h2>¿A QUIÉN DESEAS INSCRIBIR?</h2>
                                <Input
                                  type="hidden"
                                  name="suscriptor_id"
                                  value={user.id}
                                />
                                <Input
                                  type="hidden"
                                  name="suscriptor_name"
                                  value={user.nombres}
                                />
                                <Input
                                  name="nombres"
                                  placeholder="Nombres"
                                  required
                                  type="text"
                                  onKeyPress={this.validInputText}
                                />
                                <Input
                                  name="apellido_paterno"
                                  placeholder="Apellido paterno"
                                  required
                                  type="text"
                                  onKeyPress={this.validInputText}
                                />
                                <Input
                                  name="apellido_materno"
                                  placeholder="Apellido materno"
                                  //required
                                  type="text"
                                  onKeyPress={this.validInputText}
                                />
                                <div className="row">
                                  <select
                                    name="tipo_documento"
                                    onChange={this.selectDocument}
                                    required
                                    ref={ref =>
                                      (this.documentInscriptionSelect = ref)
                                    }
                                  >
                                    <option value="">Tipo de documento</option>
                                    {docTypes.map((item, index) => (
                                      <option
                                        data-length={item.max_length}
                                        key={index}
                                        value={item.id}
                                      >
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <Input
                                  name="numero_documento"
                                  disabled={!Boolean(tipo_documento)}
                                  placeholder="Número de documento"
                                  max={tipo_documento}
                                  min={5}
                                  required
                                  type="text"
                                  onKeyPress={event =>
                                    this.validInput(
                                      event,
                                      this.documentInscriptionSelect
                                    )
                                  }
                                />
                                <Input
                                  name="email"
                                  placeholder="E-mail"
                                  required
                                  type="email"
                                />
                                <Input
                                  name="telefono"
                                  placeholder="Teléfono"
                                  //pattern="[0-9]*"
                                  //required
                                  type="text"
                                  onKeyPress={this.validInput}
                                />
                                <div className="row">
                                  <p className="error">
                                    {this.state.inscriptionError}
                                  </p>
                                </div>
                                <div className="row">
                                  <Button title="Registrar" />
                                </div>
                                <span className="quest">
                                  * Datos obligatorios
                                </span>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {slides > 0 && (
                <div className="wrapper-screen">
                  <div className="screen s4">
                    <div className="container">
                      <div className="col">
                        <div className="cont-middle-col">
                          <img src={`${urlPath}/static/img/box-screen4.png`} alt="Club El Comercio" />
                        </div>
                      </div>
                      <div className="col">
                        <div className="cont-middle-col">
                          <div className="cont-white">
                            <div className="num">
                              <span>3</span>
                            </div>
                            <div className="cont-form">
                              <div className="cont">
                                <div className="head-icon">
                                  <img
                                    src={`${urlPath}/static/img/icon-beneficios.svg`}
                                    alt="Club El Comercio"
                                  />
                                </div>
                                <h2>¡FELICITACIONES!</h2>
                                <h2>Tu registro ha sido exitoso</h2>
                                <p>
                                  Hemos enviado un correo electrónico a tu
                                  adicional<br />
                                  para que pueda activar su cuenta. <br />
                                  Por favor, pidele que revise su bandeja de
                                  entrada.
                                </p>
                                <div className="cont-button aditional"><a id="btn-finish" href="https://clubelcomercio.pe/" rel="noopener noreferrer" target="_blank" className="button">Conoce tus descuentos</a></div>
                                <p>
                                  Contacto: 3115100 <br />
                                </p>
                                <p>Correo: clubelcomercio@comercio.com.pe</p>
                                <ul className="apps">
                                <li className="fb"><a id="btn-fb" href="https://www.facebook.com/ClubElComercioPeru/" rel="noopener noreferrer" target="_blank"><img alt="facebook" src={`${urlPath}/static/img/facebook-button.png`} /></a></li>
                                  <li>
                                    <a
                                      id="btn-playstore"
                                      href="https://play.google.com/store/apps/details?id=com.ec.clubsuscriptores&amp;hl=es"
                                      rel="noopener noreferrer"
                                      target="_blank"
                                    >
                                      <img
                                        alt="Play Store"
                                        src={`${urlPath}/static/img/android.png`}
                                      />
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      id="btn-appstore"
                                      href="https://itunes.apple.com/pe/app/club-el-comercio/id933383143?mt=8"
                                      rel="noopener noreferrer"
                                      target="_blank"
                                    >
                                      <img alt="App Store" src={`${urlPath}/static/img/app-store-button.png`} />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="footer">
                      <span>
                        TODOS LOS DERECHOS RESERVADOS © 2018 <br /> Club El
                        Comercio
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </div>

        {open && (
          <div className="bg-modal">
            <div className="modal">
              <a
                className="close-modal"
                onClick={() => this.setState({ open: false })}
              >
                <span>x</span>
              </a>
              <div className="cont-modal">
                <h2>Un beneficiario puede ser...</h2>
                <ul>
                  <li>Tu familiar</li>
                  <li>Tu mejor amigo</li>
                  <li>La persona que tú elijas</li>
                </ul>
                <div className="subcont-modal">
                  <p>
                    Los Suscriptores podrán registrar a un (1) Beneficiario
                    Adicional a través del Portal Web clubelcomercio.pe/
                    ingresando sus datos ahí requeridos por un período mínimo de
                    seis (6) meses, pasado este período podrá registrar
                    nuevamente un beneficiario o mantenerlo. El beneficiario
                    adicional podrá hacer uso de los beneficios automáticamente
                    una vez culminado el registro exitoso en dicho portal y se
                    emita la confirmación del mismo.
                  </p>
                  {/* <div className="cont-button">
                    <a className="button">Conoce más de un beneficiario aquí</a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js